import Env from "./env";
import Channels from "./channels";
import Swup from "swup";
import SwupGiaPlugin from "@swup/gia-plugin";
import SwupJsPlugin from "@swup/js-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
// import SwupGaPlugin from '@swup/ga-plugin';
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupProgressPlugin from "@swup/progress-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
// import SwupGtagPlugin from 'swup-gtag-plugin';
import { enableScroll, disableScroll } from "../common/ScrollDisabler";

window.tmTransition = false;

export function EmbraceTheFlame(components) {
  const swup = new Swup({
    plugins: [
      new SwupBodyClassPlugin(),
      new SwupGiaPlugin({
        firstLoad: true,
        log: false,
        components: components,
      }),
      new SwupPreloadPlugin(),
      new SwupProgressPlugin(),
      // new SwupOverlayTheme(),
      // new SwupGtagPlugin({
      //   gaMeasurementId: window.GTAG_ID
      // }),
      new SwupScrollPlugin({
        doScrollingRightAway: false,
        animateScroll: false,
      }),
      new SwupJsPlugin([
        {
          from: "(.*)",
          to: "(.*)",
          in: function (next) {
            const statusMainnav = false;

            if (statusMainnav == true) {
              Env.framework.mainnav.close(null, () => {
                // console.log('baller');
                next();
              });
            } else {
              Env.framework.TRANSITIONS.in(null, () => {
                next();
              });
            }
          },
          out: (next) => {
            const statusMainnav = false;
            // disableScroll()
            // console.log(TRANSITIONS);

            if (statusMainnav == true) {
              next();
            } else {
              Env.framework.TRANSITIONS.out(
                () => {},
                () => {
                  next();
                }
              );
            }
          },
        },
      ]),
    ],
  });

  swup.on("willReplaceContent", () => {
    Channels.emit("statechange::before");
    // Env.framework.toolbox.resetScroll()
  });

  swup.on("contentReplaced", () => {
    Channels.emit("statechange::ready");
  });

  swup.on("transitionEnd", () => {
    Channels.emit("transition::end");
    Channels.emit("statechange::finalize");
  });
}
